import { GlobalResponseObject } from "../../../global-response-object"
import { LinesInUnitModel } from "./lines-in-unit.model";

export class LinesInUnitResponse extends GlobalResponseObject {
    data?:LinesInUnitModel[];
    constructor(status: boolean, intlCode: number, internalMessage: string, data?:LinesInUnitModel[]){
        super(status,intlCode,internalMessage)
        this.data = data;
    }
}
